import Styled, { keyframes } from "styled-components";

const primary = "#145AB4";
const secondary = "#004079";
const fontColorPrimary = "#FFFFFF";
const fontColorSecondary = "#145AB4";

const backgroundLess = "transparent";
const disabledColors = {
	background: "#E5E5E5",
	color: "grey",
};

const spin = keyframes`
0% { background:transparent;  transform:rotate(720deg);}

`;

const Spinner = Styled.div`
   border-bottom: 4px dashed white;
   background:transparent;
   border-radius:100%;
   position:relative;
   width:30px;
   height: 30px;
   position:relative;
   animation: ${spin} 2s linear infinite
    `;

const StyledButton = Styled.button`
display:flex;
justify-content:center;
align-items:center;
height: 48px;
width: 40%;
border-radius:8px;
border: ${(props) =>
	props.type === "backgroundLess"
		? "solid"
		: props.type === "backgroundLess-white"
		? "2px solid white"
		: "none"};

cursor:pointer;
font-family: 'Montserrat', sans-serif;
font-weight: 700;
font-size:16px;

    :focus {
      outline:none
  }
  
    background: ${(props) => {
		if (props.disabled) return disabledColors.background;
		if (props.type === "primary") return primary;
		if (props.type === "secondary") return secondary;
		if (props.type === "backgroundLess") return backgroundLess;
		if (props.type === "backgroundLess-white") return backgroundLess;
	}};
    color: ${(props) => {
		const fontColor =
			props.type === "backgroundLess"
				? fontColorSecondary
				: fontColorPrimary;
		return props.disabled ? disabledColors.color : fontColor;
	}};
   
`;

export { StyledButton, Spinner };
